import { AxiosInstance } from "axios";

const ENTRIES_API_PREFIX = "/payments/invoice";

export interface AccumulatedEntries {
	monthlyPoints: number;
	weeklyPoints: number;
}

export const getUserAccumulatedEntries = async (
	http: AxiosInstance
): Promise<AccumulatedEntries | null> => {
	try {
			const body = await http.get<any>(`${ENTRIES_API_PREFIX}/accumulated-entries`);
			if (!body || !body.data) return null;
			const { monthlyPoints = 0, weeklyPoints = 0 } = body.data;
			return { monthlyPoints, weeklyPoints };
	} catch (error) {
		return null;
	}
};
